import ColorfulBanner from './colorful-banner';
export default ColorfulBanner;
